import React from "react"
import { Grid } from "../../atoms/grid"
import styled from "styled-components"
import Cal from "../../../images/icons/calendar.svg"

const Countdownstyle = styled.div`
  background: rgba(255, 255, 255, 0.78);
  color: #000;
  border: 1px solid #000;
  border-style: dashed;
  border-radius: 50px;
  margin: 0 0 2rem;
  p,
  b {
    margin: 0;
    font-weight: 300;
  }
  > div {
    padding: 1rem 0;
    text-align: center;
    max-width: 1080px;
    margin: 0 auto;
  }
  p {
    font-size: 0.8rem;
    > b {
      font-size: 2rem;
      font-weight: 700;
      line-height: 2.5rem;
    }
    > span {
      @media screen and (max-width: 840px) {
        display: none;
      }
    }
  }
  > div {
    max-width: 360px;
  }
  a {
    color: #fff;
    text-decoration: none;
  }
`

export class Countdown extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      days: 0,
      hours: 0,
      min: 0,
      sec: 0,
    }
  }
  componentDidMount() {
    this.interval = setInterval(() => {
      const date = this.calculateCountdown(new Date("Feb 15 2022"))
      date ? this.setState(date) : this.stop()
    }, 1000)
  }

  componentWillUnmount() {
    this.stop()
  }

  calculateCountdown(endDate) {
    let diff = (Date.parse(new Date(endDate)) - Date.parse(new Date())) / 1000

    if (diff <= 0) return false

    const timeLeft = {
      years: 0,
      days: 0,
      hours: 0,
      min: 0,
      sec: 0,
      millisec: 0,
    }

    // calculate time difference between now and expected date
    if (diff >= 86400) {
      // 24 * 60 * 60
      timeLeft.days = Math.floor(diff / 86400)
      diff -= timeLeft.days * 86400
    }
    if (diff >= 3600) {
      // 60 * 60
      timeLeft.hours = Math.floor(diff / 3600)
      diff -= timeLeft.hours * 3600
    }
    if (diff >= 60) {
      timeLeft.min = Math.floor(diff / 60)
      diff -= timeLeft.min * 60
    }
    timeLeft.sec = diff

    return timeLeft
  }

  stop() {
    clearInterval(this.interval)
  }

  addLeadingZeros(value) {
    value = String(value)
    while (value.length < 2) {
      value = "0" + value
    }
    return value
  }

  render() {
    return (
      <Countdownstyle>
        <Grid columns={4} unstack>
          <div className="time">
            <p>
              <b>{this.addLeadingZeros(this.state.days)}</b>
            </p>
            <p>{this.state.days === 1 ? "DAY" : "DAYS"}</p>
          </div>
          <div className="time">
            <p>
              <b>{this.addLeadingZeros(this.state.hours)}</b>
            </p>
            <p>HOURS</p>
          </div>
          <div className="time">
            <p>
              <b>{this.addLeadingZeros(this.state.min)}</b>
            </p>
            <p>MINS</p>
          </div>
          <div className="time">
            <p>
              <b>{this.addLeadingZeros(this.state.sec)}</b>
            </p>
            <p>SEC</p>
          </div>
        </Grid>
      </Countdownstyle>
    )
  }
}
